module.exports = {
      id: "premium-usage",
      viewBox: "0 0 576 512",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#premium",
      toString: function () {
        return this.url;
      }
    }